import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=22282718"
import script from "./DocumentCategory.vue?vue&type=script&lang=ts"
export * from "./DocumentCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports